import { StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';

const { COLOR, SPACE, UNIT } = THEME;

export default StyleSheet.create({
  dialogContainer: {
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    paddingRight: SPACE.REGULAR,
    paddingTop: (UNIT * 7.2) + SPACE.REGULAR,
  },

  dialog: {
    minWidth: UNIT * 30,
    maxWidth: UNIT * 32,
    position: 'absolute',
    right: 0,
  },

  info: {
    backgroundColor: COLOR.PRIMARY,
  },

  error: {
    backgroundColor: COLOR.ERROR,
  },
});
